// India (6)
import npsVsUpsIndia from "./nps-vs-ups-india.json";

// USA (7)
import noTaxOnTipsVsNoTaxOnOvertime from "./no-tax-on-tips-vs-no-tax-on-overtime.json";
import trumpAccountVs529VsCustodialRoth from "./trump-account-vs-529-vs-custodial-roth.json";
import irsAepVsFirstTimeAbate from "./irs-aep-vs-first-time-abate.json";
import usStudentLoanRepaymentPlans2026 from "./us-student-loan-repayment-plans-2026.json";

// UK (6)
import stocksSharesIsaVsCashIsa from "./stocks-shares-isa-vs-cash-isa.json";
import deferredPaymentCreditVsRegulatedBnpl from "./deferred-payment-credit-vs-regulated-bnpl.json";

// Australia (6)
import superVsEtfAustralia from "./super-vs-etf-australia.json";
import offsetVsRedrawAustralia from "./offset-vs-redraw-australia.json";
import indexFundVsActiveSuperAustralia from "./index-fund-vs-active-super-australia.json";
import oldQuarterlyVsNewPaydaySuper from "./old-quarterly-vs-new-payday-super.json";
import workingHolidayTaxVsResidentTaxAustralia from "./working-holiday-tax-vs-resident-tax-australia.json";
import cashSettlementVsInsurerRepairAustralia from "./cash-settlement-vs-insurer-repair-australia.json";

// Canada (6)
import fhsaVsRrsp from "./fhsa-vs-rrsp.json";
import fixedVsVariableMortgageCanada from "./fixed-vs-variable-mortgage-canada.json";
import ontarioEnhrVsFederalGstRebate from "./ontario-enhr-vs-federal-gst-rebate.json";

// Singapore (6)
import ssbVsFixedDepositSingapore from "./ssb-vs-fixed-deposit-singapore.json";
import cpfVsEtfSingapore from "./cpf-vs-etf-singapore.json";

// New Zealand (5)
import pieFundVsEtfNz from "./pie-fund-vs-etf-nz.json";

// Germany (6)
import kvdrVsPkvGermany from "./kvdr-vs-pkv-germany.json";
import lohnsteuerhilfevereinVsSteuerberater from "./lohnsteuerhilfeverein-vs-steuerberater-vermietung.json";

// Switzerland (5)

// Netherlands (5)
import annuiteitVsLineaireHypotheekNl from "./annuiteit-vs-lineaire-hypotheek-nl.json";
import box3SparenVsBeleggenNetherlands from "./box3-sparen-vs-beleggen-netherlands.json";
import box32026VsBox32028 from "./box3-2026-vs-box3-2028.json";
import zzpTaxVsRegularEmploymentNetherlands from "./zzp-tax-vs-regular-employment-netherlands.json";

import { ComparisonData } from "@/components/comparisons/types";

const rawComparisonsMap: Record<string, ComparisonData> = {
  // India
  "nps-vs-ups-india": npsVsUpsIndia as unknown as ComparisonData,

  // USA
  "no-tax-on-tips-vs-no-tax-on-overtime": noTaxOnTipsVsNoTaxOnOvertime as unknown as ComparisonData,
  "trump-account-vs-529-vs-custodial-roth": trumpAccountVs529VsCustodialRoth as unknown as ComparisonData,
  "irs-aep-vs-first-time-abate": irsAepVsFirstTimeAbate as unknown as ComparisonData,
  "us-student-loan-repayment-plans-2026": usStudentLoanRepaymentPlans2026 as unknown as ComparisonData,

  // UK
  "stocks-shares-isa-vs-cash-isa": stocksSharesIsaVsCashIsa as unknown as ComparisonData,
  "deferred-payment-credit-vs-regulated-bnpl": deferredPaymentCreditVsRegulatedBnpl as unknown as ComparisonData,

  // Australia
  "super-vs-etf-australia": superVsEtfAustralia as unknown as ComparisonData,
  "offset-vs-redraw-australia": offsetVsRedrawAustralia as unknown as ComparisonData,
  "index-fund-vs-active-super-australia": indexFundVsActiveSuperAustralia as unknown as ComparisonData,
  "old-quarterly-vs-new-payday-super": oldQuarterlyVsNewPaydaySuper as unknown as ComparisonData,
  "working-holiday-tax-vs-resident-tax-australia": workingHolidayTaxVsResidentTaxAustralia as unknown as ComparisonData,
  "cash-settlement-vs-insurer-repair-australia": cashSettlementVsInsurerRepairAustralia as unknown as ComparisonData,

  // Canada
  "fhsa-vs-rrsp": fhsaVsRrsp as unknown as ComparisonData,
  "fixed-vs-variable-mortgage-canada": fixedVsVariableMortgageCanada as unknown as ComparisonData,
  "ontario-enhr-vs-federal-gst-rebate": ontarioEnhrVsFederalGstRebate as unknown as ComparisonData,

  // Singapore
  "ssb-vs-fixed-deposit-singapore": ssbVsFixedDepositSingapore as unknown as ComparisonData,
  "cpf-vs-etf-singapore": cpfVsEtfSingapore as unknown as ComparisonData,

  // New Zealand
  "pie-fund-vs-etf-nz": pieFundVsEtfNz as unknown as ComparisonData,

  // Germany
  "kvdr-vs-pkv-germany": kvdrVsPkvGermany as unknown as ComparisonData,
  "lohnsteuerhilfeverein-vs-steuerberater-vermietung": lohnsteuerhilfevereinVsSteuerberater as unknown as ComparisonData,

  // Switzerland

  // Netherlands
  "annuiteit-vs-lineaire-hypotheek-nl": annuiteitVsLineaireHypotheekNl as unknown as ComparisonData,
  "box3-sparen-vs-beleggen-netherlands": box3SparenVsBeleggenNetherlands as unknown as ComparisonData,
  "box3-2026-vs-box3-2028": box32026VsBox32028 as unknown as ComparisonData,
  "zzp-tax-vs-regular-employment-netherlands": zzpTaxVsRegularEmploymentNetherlands as unknown as ComparisonData,
};

function buildComparisonSearchIntents(comp: ComparisonData): string[] {
  const labelA = comp.labelA || "";
  const labelB = comp.labelB || "";
  const intents = [
    `compare ${labelA.toLowerCase()} vs ${labelB.toLowerCase()}`,
    `which is better ${labelA.toLowerCase()} or ${labelB.toLowerCase()}`,
    `difference between ${labelA.toLowerCase()} and ${labelB.toLowerCase()}`,
  ];
  if (comp.country && comp.country !== "all") {
    const countryUpper = comp.country.toUpperCase();
    intents.push(`best ${comp.category.toLowerCase()} options in ${countryUpper}`);
  }
  return intents;
}

export const comparisonsMap: Record<string, ComparisonData> = {};

Object.entries(rawComparisonsMap).forEach(([key, val]) => {
  comparisonsMap[key] = {
    ...val,
    searchIntents: val.searchIntents ?? buildComparisonSearchIntents(val)
  };
});

export const comparisonsList: ComparisonData[] = Object.values(comparisonsMap);
